export default __webpack_public_path__ + "static/media/CMR.8d20c804.png";